import { useSessionInternal } from './SessionProvider';

export function useSession() {
  return useSessionInternal();
}
